$(document).on('click', '#languageTab a', function (e) {
  e.preventDefault()
  $(this).tab('show')
})
